<script lang="ts"></script>

<template>
  <nav class="flex justify-between bg-primary relative z-10">
    <header class="flex h-full xl:justify-between w-full">
      <figure class="flex h-full w-[8rem] xl:w-[7%] mx-[3%] py-3">
        <router-link :to="{ name: 'login' }" class=""
          ><img
            src="@/assets/sos-logo.png"
            alt="logo beepi"
            class="object-contain"
        /></router-link>
      </figure>
      <header class="md:hidden bg-primary p-2"></header>
      <section class="hidden md:flex items-center w-4/6 xl:w-2/5"></section>
    </header>
  </nav>
</template>
